var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLeaderboard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 20,
    r: 6.25,
    stroke: "#272727",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.50006 0.25H4.13325L3.90805 0.539545L0.408049 5.03954L0.0761719 5.46624L0.376026 5.91603L5.77663 14.0169C6.11449 13.6375 6.48397 13.2869 6.88095 12.9692L1.92396 5.53376L4.86688 1.75H20.1332L23.0762 5.53376L18.1192 12.9692C18.5162 13.2869 18.8856 13.6375 19.2235 14.0169L24.6241 5.91603L24.924 5.46624L24.5921 5.03954L21.0921 0.539545L20.8669 0.25H20.5001H4.50006Z",
    fill: "#272727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6262 11.5579L18.6455 6.38206L21.6431 1.386L20.3569 0.614258L17.5754 5.25013H7.90148L5.14454 0.61663L3.85547 1.38363L6.8294 6.38184L6.83047 6.38363L9.7871 11.4162C10.2832 11.2596 10.7978 11.1448 11.3269 11.0759L8.78549 6.75013H16.6942L14.1293 11.1472C14.6449 11.2415 15.1453 11.3798 15.6262 11.5579Z",
    fill: "#272727"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLeaderboard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/leaderboard.359d82d9e6739c8c39b952d181f04e00.svg";